import React from "react";
import Card from "../../../components/page/Card";
import { AppContext } from "../../../contexts/AppContext";
import Format from "../../../helpers/Format";
import CommonButton from "../../../components/buttons/CommonButton";

function MinhaEmpresaCard() {
  const { session, baseUrl } = React.useContext(AppContext);

  return (
    <Card margin={0}>
      <div className="row">
        <div className="col-12">
          <span className="text-muted">Razão social:</span>
          <h5 className="font-size-15">{session?.razao}</h5>
        </div>
        <div className="col-12">
          <span className="text-muted">CNPJ:</span>
          <h5 className="font-size-15">
            {Format.formatCNPJCPF(
              session?.empresa && session?.empresa.replace(/E/gi, "")
            )}
          </h5>
        </div>
      </div>
      <CommonButton
        onClick={() => {
          window.location.href = `${baseUrl}GestaoEmpresa/minhaEmpresa/Empresa/index/${session?.empresa_uid}/orangiuz`;
        }}
        color="orange"
        small
      >
        Minha empresa
        <i className="mdi mdi-arrow-right ms-1"></i>
      </CommonButton>
    </Card>
  );
}

export default MinhaEmpresaCard;
